export const formatTimestamp = (date) => {
    return (
        date.getUTCFullYear() +
        ("0" + (date.getUTCMonth()+1)).slice(-2) +
        ("0" + date.getUTCDate()).slice(-2) +
        ("0" + date.getUTCHours()).slice(-2) +
        ("0" + date.getUTCMinutes()).slice(-2)
    );
};

export const passwordTests = {
  lowercase: /.*[a-z]+.*/,
  uppercase: /.*[A-Z]+.*/,
  // Special character list from:
  // https://docs.aws.amazon.com/cognito/latest/developerguide/user-pool-settings-policies.html
  special: /.*[\^$*.\[\]{}\(\)?"!@#%&/\\,><\':;|_~`=+\-]+.*/,
  digit: /.*[\d]+.*/,
  length: 8,
  nospaces: /^\S+$/,
};
